import React from 'react'

import { Icon } from '../../..'
import { aggregationsSortingToRender, toIdString } from '../../../../utils'
import { useTranslation } from '../../../../utils/providers'

import ActiveFilters from '../ActiveFilters'
import FilterResetButton from './FilterResetButton'
import MultiSelectFilter from './MultiSelectFilter'

const filterComponents = {
  // We officially only support the list_multiselect filter. Others kept for future reference
  list_multiselect: MultiSelectFilter,
  //list_multiselect_custom_1: MultiSelectFilterGrid,
  //range_slider: RangeFilter,
}

export default function FilterSidebar({
  aggregations = {},
  numberOfActiveFilters = 0,
  submitForms,
  resetAllFilters,
  categoryUrls,
  searchData,
}) {
  const { t } = useTranslation()
  const sortedAggregationsToRender = aggregationsSortingToRender(aggregations)

  return (
    <form id="product-list-filter-form" className="desktop-filter shadow-sm">
      <div className="filter-sidebar">
        <div className="filter-sidebar__header position-relative p-3 border-bottom-1">
          <strong className="d-inline-block font-size-m text-left">
            {t('PRODUCT_LIST_FILTER_HEADING')}
          </strong>
          {numberOfActiveFilters > 0 && (
            <FilterResetButton resetAllFilters={resetAllFilters} />
          )}
        </div>
        <ul className="filter-sidebar__list">
          {sortedAggregationsToRender.map((aggregation) => {
            const { key: id, type, title, min, max } = aggregation
            const labelId = `${toIdString(id)}_label`
            const Component = filterComponents[type]

            if (!Component) return null
            return (
              <li key={id} className="filter-sidebar__list-item">
                <details>
                  <summary
                    id={labelId}
                    className="filter-sidebar__list-item-heading btn-inline"
                  >
                    <span className="sr-only">
                      {t('PRODUCT_LIST_FILTER_LABEL')(title)}
                    </span>
                    <span aria-hidden={true}>{title}</span>
                    <ActiveFilters {...aggregation} />
                    <Icon symbol="cf-chevron-down" />
                  </summary>
                  <div className="filter-sidebar__list-item-content">
                    <Component
                      // Care: The order of properties matters here, since the aggregations
                      // have a field 'key' which could override our custom-built key below
                      // which we need for properly updating/reseting the RangeFilter
                      {...aggregation}
                      key={max ? `${id}-${min}-${max}` : id}
                      id={id}
                      label={title}
                      submitForms={submitForms}
                      categoryUrls={categoryUrls}
                      searchData={searchData}
                    />
                  </div>
                </details>
              </li>
            )
          })}
        </ul>
      </div>
    </form>
  )
}
